import fetch, { parseListResponse, parseResponse } from "./fetch";

export interface ConstituantStdInterface {
    id: string;
    libel: string;
}

class ConstituantStd {
    all(params?: HashMap<any>) {
        return parseListResponse<ConstituantStdInterface>(fetch.get(`constituant_std/liste/`, { params }));
    }

    one(id: string) {
        return parseResponse<ConstituantStdInterface>(fetch.get(`constituant_std/${id}`));
    }
}

export default new ConstituantStd();
